module.exports = __webpack_public_path__ + "img/setup_guidline1.fe410f7b.png";